import { NavbarModule, PopoverModule, SharedDirectivesModule, SharedFormModule } from '@agingplan';
import { SimplemapComponent } from '@agingplan/simplemap';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookUsComponent } from './book-us/book-us.component';
import { CostOfCareMapComponent } from './cost-of-care-map/cost-of-care-map.component';
import { PublicTopNavigationComponent } from './public-top-navigation.component';

@NgModule({
  declarations: [PublicTopNavigationComponent, CostOfCareMapComponent, BookUsComponent],
  exports: [PublicTopNavigationComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedDirectivesModule, NavbarModule, PopoverModule, SharedFormModule, SimplemapComponent],
  providers: [CostOfCareMapComponent],
})
export class PublicTopNavigationModule {}
